/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseMessage } from '../../models/response-message';

export interface GetMessagesStaff$Params {
  created?: string;
  category?: string;
  subcategory?: string;
  message?: string;
  creatorName?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getMessagesStaff(http: HttpClient, rootUrl: string, params?: GetMessagesStaff$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseMessage>> {
  const rb = new RequestBuilder(rootUrl, getMessagesStaff.PATH, 'get');
  if (params) {
    rb.query('created', params.created, {});
    rb.query('category', params.category, {});
    rb.query('subcategory', params.subcategory, {});
    rb.query('message', params.message, {});
    rb.query('creatorName', params.creatorName, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseMessage>;
    })
  );
}

getMessagesStaff.PATH = '/messagesStaff';
